// Vendors
import React from 'react';
// Hooks
import { useCheckoutHook } from './hooks/checkout.hook';
// Types
import { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';

const CheckoutProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  useCheckoutHook();

  return children;
};

export { CheckoutProvider };
